import cx from 'classnames'
import Button from 'react-bootstrap/Button'

import './ButtonLink.scss'

const AnchorLink = ({ children, size = 'lg', className, href, onClick, ...props }) => {
    return (
        <a href={href} rel="noreferrer" className={'pe-none'} onClick={onClick} {...props}>
            <Button
                variant="default"
                size={size}
                className={cx('button-link pe-auto text-white bg-none rounded-0', className)}
            >
                {children}
            </Button>
        </a>
    )
}

export default AnchorLink
